module.exports = __webpack_public_path__ + "img/icon-download.fd7db5c3.svg";